import { Tooltip } from "@xola/ui-kit";
import { ICellRendererParams } from "ag-grid-community";
import React from "react";
import { InventoryRow } from "types";

export const InventorySkuCell = ({ data }: ICellRendererParams<InventoryRow>) => {
    if (!data) {
        return null;
    }

    return (
        <Tooltip content={<var data-var="sku">{data.sku}</var>}>
            <span className="no-translate cursor-default truncate">
                <var data-var="sku">{data.sku}</var>
            </span>
        </Tooltip>
    );
};
